import { render } from "./ProjectSummary.vue?vue&type=template&id=eb4ec7aa&scoped=true&ts=true"
import script from "./ProjectSummary.ts?vue&type=script&lang=ts"
export * from "./ProjectSummary.ts?vue&type=script&lang=ts"

import "./ProjectSummary.scss?vue&type=style&index=0&id=eb4ec7aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4ec7aa"]])

export default __exports__